import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { SetTagPCodeService } from './api-services/set-tag-pcode.service';

import { KYMW4602Component } from './kymw4602.component';

/**
 * タグ一括設定画面 モジュール設定クラス
 *
 * @export KYMW460202Module
 * @class KYMW4602Module
 */
@NgModule({
  imports: [CommonModule, FormsModule, PlessSharedModule, AppCommonsModule],
  declarations: [KYMW4602Component],
  providers: [SetTagPCodeService],
})
export class KYMW4602Module {}
